import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Tre bedaŭrinde, sed mi multkoloras <br/>
        Kvazaŭ sapovezik’, <br/>
        Imagu al vi…
      </p>
      
      <p class="poem-block mb-3">
        Facila kaj hela, mi flugas kun vent’, <br/>
        Sed viv’ mia daŭras dum nura moment’…
      </p>
      
      <p class="poem-block mb-3">
        Mi ŝvebas senpeze, kaj la ĉielarkoj <br/>
        Dancadas sur mi, <br/>
        Imagu al vi…
      </p>
      
      <p class="poem-block mb-3">
        Sed baldaŭ mi iĝos la akvo malpura. <br/>
        Ho kiel forkuri de l’ sorto terura?
      </p>
      
      <p class="poem-block mb-3">
        Mi estu prefere la akvo malhela <br/>
        En monta rojet’, <br/>
        Imagu al vi…
      </p>
      
      <p class="poem-block mb-3">
        Mi tiam alfluus al akvo de l’ mar’ <br/>
        Kaj ĉiam mi restus la sama akvar’.
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Mi multekoloras…'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAudio: ['mi_multekoloras'],
    itemTranslator: translator.esp
  }
}

export default item;